"use client";

import { motion, useReducedMotion } from "framer-motion";
import { Star } from "lucide-react";
export default function Stories() {
  const prefersReducedMotion = useReducedMotion();
  const testimonials = [{
    quote: "Sunil's revenue strategies transformed our OTA performance. We saw a 25% increase in direct bookings within three months.",
    name: "SARAH J.",
    meta: "GENERAL MANAGER \u00B7 BOUTIQUE HOTEL"
  }, {
    quote: "His deep knowledge of hospitality tech stacks helped us streamline operations and significantly reduce our acquisition costs.",
    name: "MARK D.",
    meta: "OWNER \u00B7 CITY CENTER SUITES"
  }, {
    quote: "A true expert in revenue management. The audit provided actionable insights that we implemented immediately for better ROI.",
    name: "ELENA V.",
    meta: "INVESTOR \u00B7 RESORT GROUP"
  }];
  const cardInitial = prefersReducedMotion ? {
    opacity: 0
  } : {
    opacity: 0,
    y: 20
  };
  const cardAnimate = prefersReducedMotion ? {
    opacity: 1
  } : {
    opacity: 1,
    y: 0
  };
  return <section data-section-id="23556" id="successstoriesmetrics" data-nav="light" className="bg-background text-foreground w-full py-12 md:py-20">
      <div className="mx-auto max-w-[1440px] px-5 md:px-12 lg:px-16">
        <div className="bg-card border border-border rounded-lg" style={{
        borderRadius: "32px"
      }}>
          <div className="px-6 py-16 sm:px-10 sm:py-20 md:px-16 md:py-24 lg:py-28">
            {}
            <div className="mx-auto flex max-w-[780px] flex-col items-center text-center">
              {}
              <motion.div initial={prefersReducedMotion ? {
              opacity: 0
            } : {
              opacity: 0,
              scale: 0.9
            }} whileInView={prefersReducedMotion ? {
              opacity: 1
            } : {
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.6,
              ease: [0.22, 1, 0.36, 1]
            }} aria-hidden="true" className="mb-8 flex items-center justify-center" style={{
              width: "56px",
              height: "56px"
            }}>
                <svg viewBox="0 0 56 56" fill="none" className="h-14 w-14" style={{
                color: "var(--primary)"
              }}>
                  <circle cx="28" cy="28" r="27" stroke="currentColor" strokeWidth="1" fill="none" />
                  <circle cx="28" cy="28" r="22" stroke="currentColor" strokeWidth="1" fill="none" />
                  <path d="M28 14 L30.5 22.5 L39.5 22.5 L32.2 27.8 L34.9 36.3 L28 31 L21.1 36.3 L23.8 27.8 L16.5 22.5 L25.5 22.5 Z" fill="currentColor" />
                </svg>
              </motion.div>

              <motion.h2 initial={prefersReducedMotion ? {
              opacity: 0
            } : {
              opacity: 0,
              y: 16
            }} whileInView={prefersReducedMotion ? {
              opacity: 1
            } : {
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.7,
              ease: [0.22, 1, 0.36, 1]
            }} className="font-default text-foreground text-4xl font-extrabold uppercase leading-[0.94] sm:text-5xl md:text-6xl lg:text-7xl" style={{
              letterSpacing: "-0.035em"
            }}>
                Client Success
              </motion.h2>

              <motion.p initial={prefersReducedMotion ? {
              opacity: 0
            } : {
              opacity: 0,
              y: 16
            }} whileInView={prefersReducedMotion ? {
              opacity: 1
            } : {
              opacity: 1,
              y: 0
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.7,
              delay: 0.08,
              ease: [0.22, 1, 0.36, 1]
            }} className="font-default text-muted-foreground mt-6 text-lg leading-[1.5] sm:text-xl md:text-[1.375rem]" style={{
              letterSpacing: "-0.005em"
            }}>
                Proven results for hotels.
              </motion.p>

              {}
              <motion.div initial={prefersReducedMotion ? {
              opacity: 0
            } : {
              opacity: 0,
              scaleX: 0.6
            }} whileInView={prefersReducedMotion ? {
              opacity: 1
            } : {
              opacity: 1,
              scaleX: 1
            }} viewport={{
              once: true,
              amount: 0.4
            }} transition={{
              duration: 0.7,
              delay: 0.15,
              ease: [0.22, 1, 0.36, 1]
            }} aria-hidden="true" className="mt-10 flex items-center justify-center">
                <svg viewBox="0 0 240 24" className="h-6 w-full max-w-[240px]" fill="none" style={{
                color: "var(--primary)"
              }}>
                  <path d="M20 12 Q40 4 60 12 Q75 18 88 12" stroke="currentColor" strokeWidth="1" strokeLinecap="round" fill="none" />
                  <path d="M30 12 Q45 8 55 12" stroke="currentColor" strokeWidth="1" strokeLinecap="round" fill="none" />
                  <path d="M40 12 Q50 10 58 12" stroke="currentColor" strokeWidth="1" strokeLinecap="round" fill="none" />
                  <path d="M120 4 L122.5 10 L129 10 L124 14 L126 20 L120 16 L114 20 L116 14 L111 10 L117.5 10 Z" fill="currentColor" />
                  <path d="M220 12 Q200 4 180 12 Q165 18 152 12" stroke="currentColor" strokeWidth="1" strokeLinecap="round" fill="none" />
                  <path d="M210 12 Q195 8 185 12" stroke="currentColor" strokeWidth="1" strokeLinecap="round" fill="none" />
                  <path d="M200 12 Q190 10 182 12" stroke="currentColor" strokeWidth="1" strokeLinecap="round" fill="none" />
                </svg>
              </motion.div>
            </div>

            {}
            <div className="mt-16 grid grid-cols-1 gap-8 md:mt-20 md:grid-cols-3">
              {testimonials.map((t, i) => <motion.div key={i} data-index={i} initial={cardInitial} whileInView={cardAnimate} viewport={{
              once: true,
              amount: 0.2
            }} transition={{
              duration: 0.6,
              delay: prefersReducedMotion ? 0 : i * 0.1,
              ease: [0.22, 1, 0.36, 1]
            }} whileHover={prefersReducedMotion ? undefined : {
              transition: {
                duration: 0.24
              }
            }} className="group bg-card flex flex-col p-8 sm:p-10 transition-colors duration-300 hover:bg-accent" style={{
              borderRadius: "24px",
              minHeight: "340px"
            }}>
                  {}
                  <div className="mb-6" aria-hidden="true">
                    <motion.div className="flex items-center" initial={{
                  scale: 1
                }} whileHover={prefersReducedMotion ? undefined : {
                  scale: 1.18,
                  transition: {
                    type: "spring",
                    stiffness: 320,
                    damping: 18
                  }
                }}>
                      <svg viewBox="0 0 44 44" className="h-11 w-11 sm:h-11 sm:w-11" fill="none" style={{
                    color: "var(--primary)"
                  }}>
                        <path d="M8 26 C8 18, 14 12, 20 10 L20 14 C16 15, 13 18, 13 22 L18 22 C19 22, 20 23, 20 24 L20 32 C20 33, 19 34, 18 34 L10 34 C9 34, 8 33, 8 32 Z" fill="currentColor" />
                        <path d="M26 26 C26 18, 32 12, 38 10 L38 14 C34 15, 31 18, 31 22 L36 22 C37 22, 38 23, 38 24 L38 32 C38 33, 37 34, 36 34 L28 34 C27 34, 26 33, 26 32 Z" fill="currentColor" />
                        <path d="M4 8 L6 12 L10 12 L7 15 L8 19 L4 17 L0 19 L1 15 L-2 12 L2 12 Z" fill="currentColor" transform="translate(4 -2)" />
                      </svg>
                    </motion.div>
                  </div>

                  {}
                  <p className="font-default text-foreground text-lg leading-[1.5] sm:text-xl md:text-[1.375rem] flex-1" style={{
                letterSpacing: "-0.005em"
              }}>
                    {t.quote}
                  </p>

                  {}
                  <div className="mt-8" style={{
                height: "1px",
                backgroundColor: "var(--border)"
              }} aria-hidden="true" />

                  {}
                  <div className="mt-6 flex flex-wrap items-baseline justify-between gap-x-4 gap-y-2">
                    <h3 className="font-default text-foreground text-lg font-bold uppercase leading-[1.1] sm:text-xl" style={{
                  letterSpacing: "-0.01em"
                }}>
                      {t.name}
                    </h3>
                    <span className="font-mono text-muted-foreground text-xs sm:text-sm uppercase" style={{
                  letterSpacing: "0.04em"
                }}>
                      {t.meta}
                    </span>
                  </div>
                </motion.div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}